import { render, staticRenderFns } from "./RegistrarVendedor.vue?vue&type=template&id=652c3ece&scoped=true&"
import script from "./RegistrarVendedor.vue?vue&type=script&lang=js&"
export * from "./RegistrarVendedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652c3ece",
  null
  
)

export default component.exports